import {Layout} from "./Layout.js";


export class SnsButtonsLayout extends Layout {

    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            ${this.getNexPageButtonTemplate()}
                        </div>
                    </article>
                </section>`
    }
}
